import { createSelector } from '@reduxjs/toolkit';
import { ILeaveOrganizationRoot } from './models';

export const selectLeaveOrganization = (state: ILeaveOrganizationRoot) => state.leaveOrganization;
export const selectLeaveOrgPhase = createSelector(selectLeaveOrganization, ({ phase }) => phase);
